export default __webpack_public_path__ + "static/media/service-month.88ef2268.jpg";